import { ReactElement } from 'react';
import { Button, Typography } from '@mui/material';

import { ShareIcon } from 'modules/common/icons';
import { useGlobalTranslation } from 'modules/i18n';
import { useStakeToken } from 'modules/liquidStaking/hooks/useStakeToken';

import { translation } from './translation';
import { useStyles } from './useStyles';

interface IExploreProps {
  link: string;
}

export function Explore({ link }: IExploreProps): ReactElement {
  const { t, keys } = useGlobalTranslation(translation);
  const { classes } = useStyles();

  const { name } = useStakeToken();

  return (
    <div className={classes.root}>
      <div className={classes.info}>
        <Typography fontSize={15} fontWeight={600}>
          {t(keys.title)}
        </Typography>

        <Typography
          color={theme => theme.palette.text.secondary}
          variant="body1"
        >
          {t(keys.description, { stakeToken: name })}
        </Typography>
      </div>

      <Button
        className={classes.button}
        color="secondary"
        component="a"
        href={link}
        rel="noreferrer"
        target="_blank"
        variant="outlined"
      >
        <span>{t(keys.common.explore)}</span>

        <ShareIcon />
      </Button>
    </div>
  );
}
